const ptBr = {
  modals: {
    success: {
      buttonLabel: "OK",
    },
    errors: {
      buttonLabel: "Ok",
    },
  },

  Pages: {
    home: "Sobre",
    career: "Carreira",
    experiences: "Experiências",
    skills: "habilidades",
    work: "Trabalhos",
  },
  footer: {
    modeText:
      "Modo: Vivendo, aprendendo, e tentando evoluir um dia de cada vez.",
    madeByText: ["Feito em React por:", "Caroliny Lima"],
  },
  home: {
    title: "Desenvolvedora de Sistemas",
    gamesPopLifeText: "Fã de games e cultura pop",
    fitLifeText: "Curtindo a vida Fitness",
    codeLifeText: "Apaixonada pelos desafios de programar",
    text: [
      "Olá, sou Caroliny e seja bem-vindo(a) ao meu site! Mas quem sou eu? Bom, aqui vai um resuminho!",
      "Sou a pessoa em busca do shape perfeito e de uma vida saudável quando estou na academia.",
      "Eu me transformo nos personagens dos games quando estou no modo play.",
      "Também sou a protagonista guerreira, heroína ou vilã dos filmes e séries de ficção científica, ação e terror que adoro assistir.",
      "Além disso, sou uma aprendiz dedicada de desenvolvimento de sistemas, estudando com cursos, meu computador, livros e muito café.",
      "Estou sempre me atualizando e buscando adquirir novas habilidades."
    ],

    textActivitiesLeft: [
      "Contato com o UI designer para visualização e leitura de mockups e protótipos dos projetos com Adobe XD e Figma.",
      "Criação de projetos front-end com interfaces contendo layouts responsivos e componentes funcionais utilizando das linguagens JavaScript ou TypeScript com sintaxe jsx e biblioteca React. Além de ferramentas HTML5, CSS, styled-components, Material-UI, Chart.js, react-router-dom, React Hooks, VS Code, ambiente node.js, versionamento e sistemas de controle Git.",
    ],

    textActivitiesRight: [
      "Integração dos sistemas web com métodos do protocolo HTTP, API RESTful, biblioteca Axios ou Apisauce e correção de bugs.",
      "Trabalho em equipe sob metodologia SCRUM utilizando das plataformas GitLab ou Redmine, reuniões de planejamento de Sprints dos projetos e daily SCRUM com reuniões diárias de acompanhamento das atividades dos projetos.",
    ],
  },

  career: {
    avatarText: "Pensar como programadora... Trabalhar como desenvolvedora... Transformar a arte de programar em algo inovador... Eu amo o que faço!",
    ComapnyImageText: "Iniciei minha carreira na área de Tecnologia da Informação como estagiária de programação front-end para a empresa PalmSoft e a startup Deepen, que pertence à PalmSoft. Posteriormente, nessas incríveis empresas, tornei-me desenvolvedora front-end júnior. A PalmSoft e a Deepen me ajudaram a pensar como programadora e a descobrir a desenvolvedora dentro de mim.",
    checkComerceCarrerText: "Em seguida, ingressei no setor de e-commerce, onde iniciei uma nova trajetória na empresa Check Commerce, atuando com suporte e desenvolvimento front-end para lojas virtuais. Essa experiência foi bastante enriquecedora, pois me permitiu compreender o funcionamento da área de tecnologia voltada ao comércio eletrônico, além de aprender novas ferramentas e processos para o desenvolvimento de projetos e-commerce.",
  },

  experiences: {
    experiencesText: "Tenho 3 anos de experiência em desenvolvimento de projetos front-end para aplicações web, atuando principalmente em projetos B2B. Trabalhei de forma híbrida, o que me permitiu desenvolver habilidades tanto em ambientes presenciais quanto remotos. Minhas principais experiências incluem:",
    textExperiencesLeft: [
      "Leitura de mockups e protótipos dos projetos através de ferramentas de design Adobe XD e Figma.",
      "Criação de projetos front-end com interfaces contendo layouts responsivos e componentes funcionais utilizando JavaScript ou TypeScript com sintaxe JSX e a biblioteca React. Além disso, utilizo ferramentas como HTML5, CSS, styled-components, Material-UI, Chart.js, react-router-dom, React Hooks, VS Code, ambiente Node.js, versionamento e sistemas de controle Git.",
    ],

    textExperiencesRight: [
      "Integração dos sistemas web com operações CRUD, métodos do protocolo HTTP, API RESTful, biblioteca Axios ou Apisauce, e correção de bugs.",
      "Trabalho em equipe sob a metodologia SCRUM e KANBAN utilizando plataformas como GitLab ou Redmine, participando de reuniões de planejamento de Sprints dos projetos e daily SCRUM com reuniões diárias para acompanhamento das atividades dos projetos.",
    ],
    practicalExperiencesText: "Algumas das minhas experiências na prática!",
    titleCodeDemoButtonComponent: "Submissão do Formulário: Campos de entrada (inputs) de um formulário e botão submit",
    titleCodeDemoSelectionDropDown: "Componente Selection DropDown: botão com seleção de opções que abrem modais:",
    titleCodeDemoUploadComponent: "Upload de arquivos de imagens: componente de upload e botão de envio do arquivo de imagem em base64:"
  },

  Skills: {
    SkillsTitle: ["HARD SKILLS", "SOFT SKILLS"],
    levelTitle: ["FRONT-END", "BACK-END"],
    level: ["Junior", "Pleno", "Sênior"],
    DashboardText: [
      "No dashboard abaixo, é possível conferir as ferramentas com as quais tenho experiência no desenvolvimento de sistemas, além do nível de conhecimento que possuo em cada uma delas:",
      "No dashboard ao lado, é possível conferir minhas habilidades interpessoais e comportamentais, refletindo minha personalidade e inteligência emocional. Essas habilidades são fundamentais tanto na minha vida pessoal quanto no ambiente de trabalho:"
    ],
    chartsTitle: ["LINGUAGENS", "FERRAMENTAS FRONT-END", "FERRAMENTAS BACK-END", "OUTRAS FERRAMENTAS", "COMPETÊNCIAS"],
  },

  Works: {
    worksTitle: ["Projetos", "Clientes"],
    worksText: ["Atualmente, atuo como freelancer front-end na PalmSoft e Deepen, onde recentemente estou desenvolvendo o sistema Plurio, uma plataforma de gestão de assinaturas digitais voltada para clientes empresas. O sistema ainda não apresenta integração com uma API back-end por estar em fase de desenvolvimento.",
      "Além de atuar como freelancer, concluí o bootcamp imersivo em JavaScript focado em back-end pela Reprograma. Durante o curso, desenvolvi meu primeiro projeto back-end, a API PetLivre, uma plataforma que facilita o acesso de usuários de baixa renda a serviços veterinários. A API permite que tutores criem contas, registrem seus pets e encontrem clínicas veterinárias próximas para vacinação gratuita e medicamentos com desconto. O sistema também permite o agendamento de visitas domiciliares para quem não pode levar o pet à clínica, exigindo, no cadastro, uma descrição do pet e a comprovação de baixa renda do dono. Além disso, ONGs e programas podem se registrar para oferecer campanhas de vacinação e conteúdos educativos diretamente na plataforma. O projeto está em fase de desenvolvimento, atualmente com CRUDs implementados para tutores e pets",
      "Estes são os clientes para os quais participei no desenvolvimento dos projetos durante minha atuação na PalmSoft e na Deepen."
    ],
    gitHubButton: "Ropositório do projeto"
  },
};

const Texts = {
  ptBr,
};
export default Texts;
